import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import { Button } from '@workramp/ui';
import { showLoader, hideLoader } from '../../common';
import Modal from './modal';
import FileUploader from './file_uploader';
import UploadWithProgress from './upload-with-progress';

class EditCardBannerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardBannerURL: props.cardBannerURL,
      upload: null,
    };
  }

  render() {
    const defaultCoverImagesKey = this.props.defaultCoverImagesKey || 'ADDITIONAL';
    const defaultImageURLs = [this.props.defaultCoverForType].concat(
      _.values(APP_CONSTANTS.DEFAULT_COVER_IMAGES[defaultCoverImagesKey]),
    );
    return (
      <ModalWrapper>
        <Modal
          show={this.props.show}
          title={this.props.title || 'Edit Cover Image'}
          onClose={this.props.onClose}
          onSave={this.props.onClose}
          showBackdrop={this.props.showBackdrop}
          cancelButtonTitle="Close"
          dontShowSaveButton
        >
          <div>
            <CardWrapper style={this.props.cardWrapperStyle || {}}>
              {this.props.card(this.state.cardBannerURL)}
            </CardWrapper>
          </div>
          <ImageSelectionWrapper>
            <GalleryWrapper>
              <GalleryHeader>Select a Stock Image</GalleryHeader>
              <Gallery>
                {_.map(defaultImageURLs, (imageURL) => (
                  <InnerImg onClick={(_e) => this.stockImageClick(imageURL)} key={imageURL} src={imageURL} />
                ))}
              </Gallery>
            </GalleryWrapper>
            <UploadWrapper>
              <FileUploader handler={this.onFileUpload} icon={<Button>Upload Custom Image</Button>} accept="image/*" />
              {this.state.upload && (
                <UploadWithProgress
                  data={this.state.upload.data}
                  url={this.props.cardBannerUploadUrl}
                  name={null}
                  method="PUT"
                  uploadCompleted={this.handleUploadEndState}
                  uploadFailed={this.handleUploadEndState}
                  onlyShowProgressBar
                />
              )}
            </UploadWrapper>
          </ImageSelectionWrapper>
        </Modal>
      </ModalWrapper>
    );
  }

  stockImageClick = (imgUrl) => {
    if (this.props.stockImageUploadHandler) {
      return this.props.stockImageUploadHandler(imgUrl, (err, cardBannerURL) => this.setState({ cardBannerURL }));
    }

    this.props.editCardBanner(imgUrl, (err, cardBannerURL) => this.setState({ cardBannerURL }));
  };

  onFileUpload = (event) => {
    event.preventDefault();
    const file = event.target.files[0];

    if (file.type.substring(0, 5) !== 'image') {
      alert('Please upload a valid image.');
      return;
    }

    const data = new FormData();
    data.append('card_banner', file);

    if (file && data) {
      const upload = {
        data,
        name: file.name,
      };
      showLoader();
      this.setState({ upload });
    }
  };

  handleUploadEndState = (result) => {
    hideLoader();
    this.props.editCardBanner(result.cardBanner, (err, cardBannerURL) => this.setState({ cardBannerURL }));
  };
}

const ImageSelectionWrapper = styled.div`
  display: flex;
  height: 235px;
`;

const GalleryWrapper = styled.div`
  width: calc(50% - 20px);
  padding-right: 20px;
  border-right: 1px solid grey;
  height: 100%;
  position: relative;

  &:after {
    content: 'OR';
    position: absolute;
    right: -13px;
    top: calc(50% - 19px);
    border-top: 10px solid white;
    border-bottom: 10px solid white;
    background: white;
  }
`;

const GalleryHeader = styled.div`
  text-align: center;
  padding-bottom: 15px;
`;

const Gallery = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  height: 205px;
`;

const UploadWrapper = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InnerImg = styled.div`
  height: 60px;
  width: 77px;
  background-image: ${(props) => (props.src ? `url(${props.src})` : '')};
  background-position: center;
  background-size: cover;
  box-sizing: border-box;
  cursor: pointer;
`;

const ModalWrapper = styled.div`
  .modal {
    z-index: 1060;
  }
`;

const CardWrapper = styled.div`
  margin: 5% 0;
  padding: 35px 25%;
  background-color: #f3f5f8;
`;

export default EditCardBannerModal;
